import { useMemo } from 'react';

import {
  projectStatusByCode,
  projectStatusConfig,
  ProjectStatusConfig,
  taskStatusByCode,
  taskStatusesConfig,
  User,
} from 'entities';

import { useProject } from 'providers/Project';
import { useUser } from 'hooks';

import { sortByName } from 'utils/array';

export function useUserEntries(user?: User) {
  const { projectList } = useProject();
  const loggedUser = useUser();

  const { canAssumeProject, hasServices } = loggedUser.team;

  const refId = user?.id ?? loggedUser.id;

  const userEntries = useMemo(() => {
    return {
      projects: canAssumeProject
        ? sortByName(
            projectList.filter(
              ({ owner, status }) =>
                owner.id === refId && projectStatusByCode[status].shownOnActivePage,
            ),
          )
        : [],

      tasks: hasServices
        ? sortByName(
            projectList
              .map(({ tasks }) =>
                tasks.filter(
                  ({ owner, status }) =>
                    owner.id === refId && taskStatusByCode[status].isActiveStatus,
                ),
              )
              .flat(),
          )
        : [],
    };
  }, [projectList, refId, canAssumeProject, hasServices]);

  const getStatusColor = (statusCode: string): string => {
    const config = canAssumeProject ? projectStatusConfig : taskStatusesConfig;

    const { color } = Object.values(config).find(
      ({ code }) => code === statusCode,
    ) as ProjectStatusConfig;

    return color;
  };

  return {
    ...userEntries,
    getStatusColor,
  };
}
